import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember, TypedJSON} from 'typedjson';
import {FrequencyPlanChannel} from '@/model/lora/FrequencyPlanChannel';

@jsonObject({
  onDeserialized: 'onDeserialized',
})
export class FrequencyPlan {

  public static get Serializer(): TypedJSON<FrequencyPlan> {
    if (!FrequencyPlan.serializer) {
      FrequencyPlan.serializer = new TypedJSON(FrequencyPlan);
    }

    return FrequencyPlan.serializer;
  }

  private static serializer: TypedJSON<FrequencyPlan> | undefined;

  @jsonMember({name: 'id'})
  public Id!: string;

  @jsonMember({name: 'label'})
  public Label!: string;

  @jsonMember({name: 'description'})
  public Description!: string;

  @jsonArrayMember(String, {name: 'countries'})
  public Countries!: string[];

  @jsonArrayMember(FrequencyPlanChannel, {name: 'channels'})
  public Channels!: FrequencyPlanChannel[];

  public get IdClean(): string {
    return this.Id.replaceAll('_', ' ');
  }

  private onDeserialized() {
    if (this.Channels) {
      this.Channels.sort((a, b) => {
        return a.Frequency - b.Frequency;
      }).sort((a, b) => {
        return a.Radio - b.Radio;
      }).sort((a, b) => {
        return -a.Type.localeCompare(b.Type);
      });
    }
  }
}
